import React from 'react'

export const LockIcon: React.FC = () => (
  <svg
    className="results-action-icon-svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M17 8h-1V6a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 1 1 4 0v2h-4V6Zm2 8a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 1-1Z" />
  </svg>
)

export const UnlockIcon: React.FC = () => (
  <svg
    className="results-action-icon-svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M17 8h-6V6a2 2 0 1 1 4 0h2a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-5 6a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 1-1Z" />
  </svg>
)
